import React, { useEffect, useRef, useState } from "react";
import "./Header.css";
import Icons from "../../../../Config/Images";
import { useLocation, useNavigate } from "react-router-dom";
import { getSearchAPI } from "../../../../Store/Action/globalSearchAction";
import { useDispatch, useSelector } from "react-redux";
import Timer from "../Timer";
import CustomImageComponent from "../../CustomComponents/CustomImageComponent";
import { getMenuDetailsAPI } from "../../../../Store/Action/menu";
import SubcategoriesByCategory from "../../CustomComponents/SubCategoryByCategory";
import {
  getProductCategoryByCategoryIdAPI,
  getProductCategoryByCategoryNameAPI,
  getProductCategoryDetailsAPI,
} from "../../../../Store/Action/productCategory";
import { getCartAPI } from "../../../../Store/Action/cartAction";
import {
  FaUser,
  FaBox,
  FaMapMarkerAlt,
  FaWallet,
  FaGift,
  FaSyncAlt,
  FaFileAlt,
  FaSignOutAlt,
  FaTrash,
} from "react-icons/fa";
import MyAccountSidebar from "../../Auth/MyAccountSideBar";
import { getActiveSubscriptionAPI } from "../../../../Store/Action/subscriptionAction";
import { getLiveRateAPI } from "../../../../Store/Action/globalAction";

const Header = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isAccountSideBarOpen, setIsAccountSideBarOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const [showDropdown, setShowDropdown] = useState(false);
  const [isLanguageDropdownOpen, setIsLanguageDropdownOpen] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState("EN");

  const [menuData, setMenuData] = useState([]);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [categoriesLoaded, setCategoriesLoaded] = useState(false); // Track when data is loaded

  const [hovering, setHovering] = useState(false);
  const [cartLength, setCartLength] = useState(null);
  // const [isHoveringDropdown, setIsHoveringDropdown] = useState(false);
  // const [isHoveringCategory, setIsHoveringCategory] = useState(false);

  const searchInputRef = useRef(null);

  const dropdownRef = useRef(null);
  const newRef = useRef(null); // New ref added
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  //navigate on home route
  const handleLogoClick = () => {
    // navigate("/");
    if (window.location.pathname === "/home") {
      // If already on the home page, just scroll to top
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      // Navigate to home and scroll to top
      navigate("/home");
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 100); // Delay to ensure smooth transition
    }
  };
  //navigate on cart route
  const handleCartClick = () => {
    navigate("/cart-brands");
  };
  //navigate on wishlist route
  const handleWishlistClick = () => {
    navigate("/wishlist");
  };
  //navigate on account route
  const handleAccountClick = () => {
    // navigate("/my-account");
    setIsAccountSideBarOpen(!isAccountSideBarOpen);
  };

  useEffect(() => {
    const fetchSearchResults = async () => {
      if (!searchTerm) {
        setSearchResults([]);
        setShowDropdown(false);
        return;
      }

      try {
        dispatch(
          getSearchAPI(searchTerm, (result) => {
            setSearchResults(result);
            setShowDropdown(true);
          }),
        );
      } catch (error) {
        console.log("Failed to fetch search results:", error);
      }
    };

    const debounceTimeout = setTimeout(fetchSearchResults, 300); // Debounce delay

    return () => clearTimeout(debounceTimeout); // Cleanup debounce on searchTerm change
  }, [searchTerm]);

  const handleSearchChange = (event) => {
    const value = event.target.value; // Remove leading/trailing spaces

    setSearchTerm(value);

    // Only trigger API call if the search term is not empty
    if (value) {
      setSearchResults([]); // Clear previous results
      setShowDropdown(true);
    } else {
      setSearchResults([]); // Clear results if search term is empty
      setShowDropdown(false);
    }
  };

  const handleClickOfTheProduct = (product, result) => {
    if (result?.category == "product category") {
      const categoryName = product?.product_name;
      const categoryId = product?.product_category_id;
      dispatch(
        getProductCategoryByCategoryIdAPI(categoryId, (result) => {
          const fetchedSubCategories = result?.data[0]?.product_sub_categories;
          if (fetchedSubCategories.length > 0) {
            navigate("/sub-categories", {
              state: { subCategories: fetchedSubCategories },
            });
          } else {
            navigate(`/productsList/${categoryId}`, {
              state: {
                subCategoryId: categoryId,
                subCategoryName: categoryName,
              },
            });
          }
        }),
      );
    } else {
      const formattedName = product?.product_name
        ?.toLowerCase() // Convert to lowercase
        .trim() // Trim spaces at the beginning and end
        .replace(/\s+/g, "-") // Replace one or more spaces with a hyphen
        .replace(/[^a-z0-9\-]/g, "") // Remove all non-alphanumeric characters except hyphens
        .replace(/-+/g, "-") // Replace multiple hyphens with a single hyphen
        .replace(/^-+/, "") // Remove any leading hyphens
        .replace(/-+$/, ""); // Remove any trailing hyphens

      // return
      navigate(`/productDetail/${formattedName}`, {
        state: { productId: product.product_id },
      });
    }
  };

  // Hide dropdown when clicking outside the search input or dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        searchInputRef.current &&
        !searchInputRef.current.contains(event.target) &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        setShowDropdown(false);
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Toggle the language dropdown visibility
  const handleOpenLanguagedropdown = () => {
    setIsLanguageDropdownOpen((prevState) => !prevState); // Toggle the dropdown
  };

  // Handle language selection
  // const handleLanguageChange = (event) => {
  //   setSelectedLanguage(event.target.value); // Update selected language
  // };
  const handleLanguageChange = (e) => {
    const langMap = {
      EN: "en",
      HI: "hi",
      GJ: "gu",
      // Add more mappings if needed
    };

    const langCode = langMap[e.target.value];
    const selected = e.target.value;
    setSelectedLanguage(selected);

    // Store in localStorage
    localStorage.setItem("selectedLanguage", selected);

    if (langCode) {
      // Set the cookie to force Google Translate
      document.cookie = `googtrans=/en/${langCode}`;
      document.cookie = `googtrans=/en/${langCode};domain=${window.location.hostname}`;
      document.cookie = `googtrans=/en/${langCode};path=/`;

      // Reload the page to apply translation
      window.location.reload();
    }
  };
  useEffect(() => {
    const savedLang = localStorage.getItem("selectedLanguage");
    if (savedLang) {
      setSelectedLanguage(savedLang);
    }
  }, []);
  const handleNavigate = (menuSlug) => {
    switch (menuSlug) {
      case "/":
        if (location.pathname === "/home") {
          // Already on /home, just manually scroll
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else {
          navigate("/home"); // Let ScrollToTop handle the scroll
        }
        break;
      case "categories":
        // setIsDropdownOpen(true); // Open dropdown when hovering "Categories"
        // setIsHoveringCategory(true); // Track hover state on "Categories"
        break;
      case "our-brands":
        navigate("/our-brands");
        break;
      case "new-arrivals":
        navigate("/new-arrival-products", { state: "fromNewArrival" });
        break;
      case "about-us":
        navigate("/about-us", { state: { fromAboutUsByLoggedInUser: true } });
        break;
      case "contact-us":
        navigate("/contact-us", {
          state: { fromContactUsByLoggedInUser: true },
        });
        break;
      default:
        console.log(`No route defined for slug: ${menuSlug}`);
    }
  };
  useEffect(() => {
    if (!hovering) {
      const timeout = setTimeout(() => {
        setIsDropdownOpen(false);
      }, 200); // Delay to prevent flickering
      return () => clearTimeout(timeout);
    }
  }, [hovering]);

  useEffect(() => {
    dispatch(
      getMenuDetailsAPI("", (result) => {
        setMenuData(result);
      }),
    );
  }, [dispatch]);

  useEffect(() => {
    dispatch(
      getCartAPI({}, (result) => {
        setCartLength(result?.data?.length);
      }),
    );
  }, [dispatch]);
  const [showTimer, setShowTimer] = useState(false);
  const [hasSubscription, setHasSubscription] = useState(false);
  const [isLoading, setIsLoading] = useState(true); // Track loading state
  useEffect(() => {
    dispatch(
      getActiveSubscriptionAPI({}, (result) => {
        setHasSubscription(result?.length > 0);
        setIsLoading(false); // API call completed
      }),
    );
  }, []);

  const handleMouseEnter = (menu) => {
    if (menu.menu_slug === "categories") {
      if (!categoriesLoaded) {
        return;
      }
      setIsDropdownOpen(true);
      setHovering(true);
    }
  };

  const handleMouseLeave = () => {
    // setIsDropdownOpen(false);
    setHovering(false);
  };
  const [productCategory, setProductCategory] = useState([]); // ✅ Define this state

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        dispatch(
          getProductCategoryDetailsAPI({}, (result) => {
            if (result?.data?.length > 0) {
              setProductCategory(result.data);
              setCategoriesLoaded(true); // ✅ Now data is ready before hover
            } else {
              setCategoriesLoaded(false);
            }
          }),
        );
      } catch (error) {
        console.log("Failed to fetch categories:", error);
      }
    };

    fetchCategories();
  }, [dispatch]); // ✅ Load once when the component mounts

  const [liveRate, setLiveRate] = useState([]);
  const [bgGold, setBgGold] = useState("");
  const [bgSilver, setBgSilver] = useState("");

  const previousGoldOpen = useRef(null);
  const previousSilverOpen = useRef(null);
  useEffect(() => {
    // Fetch initially
    dispatchLiveRate();

    const intervalId = setInterval(() => {
      dispatchLiveRate();
    }, 2000);

    return () => clearInterval(intervalId);
  }, []);

  // const dispatchLiveRate = () => {
  //   dispatch(
  //     getLiveRateAPI({}, (result) => {
  //
  //       // const gold = result?.find(
  //       //   (item) => item.name.trim().toLowerCase() === "gold 999 imp"
  //       // );
  //       // const silver = result?.find(
  //       //   (item) => item.name.trim().toLowerCase() === "silver  5 kg"
  //       // );

  //       const normalizeName = (name) =>
  //         name?.toLowerCase().replace(/\s+/g, " ").trim();

  //       const gold = result?.find(
  //         (item) => normalizeName(item.name) === "gold 999 imp"
  //       );

  //       const silver = result?.find(
  //         (item) => normalizeName(item.name) === "silver 5 kg"
  //       );

  //       // Compare with previous and update bg
  //       if (gold && previousGoldOpen.current !== null) {
  //         if (gold.ltp > previousGoldOpen.current) {
  //           setBgGold("green");
  //         } else if (gold.ltp < previousGoldOpen.current) {
  //           setBgGold("red");
  //         } else {
  //           setBgGold("#9c7726");
  //         }
  //       }

  //       if (silver && previousSilverOpen.current !== null) {
  //         if (silver.ltp > previousSilverOpen.current) {
  //           setBgSilver("green");
  //         } else if (silver.ltp < previousSilverOpen.current) {
  //           setBgSilver("red");
  //         } else {
  //           setBgSilver("#c0c0c0");
  //         }
  //       }

  //       // Update previous values
  //       if (gold) previousGoldOpen.current = gold.ltp;
  //       if (silver) previousSilverOpen.current = silver.ltp;

  //       setLiveRate(result);

  //       // Reset color after 1 second
  //       setTimeout(() => {
  //         setBgGold("");
  //         setBgSilver("");
  //       }, 1000);
  //     })
  //   );
  // };

  // Filter for GOLD and SILVER entries

  const dispatchLiveRate = () => {
    dispatch(
      getLiveRateAPI({}, (result) => {
        if (!result?.status || !result?.data) return;

        const data = result.data;

        const normalizeName = (name) =>
          name?.toLowerCase().replace(/\s+/g, " ").trim();

        const gold = data.find(
          (item) => normalizeName(item.commodity) === "gold 24k",
        );

        const silver = data.find(
          (item) => normalizeName(item.commodity) === "silver",
        );

        // Compare with previous and update bg
        if (gold && previousGoldOpen.current !== null) {
          if (gold.rate > previousGoldOpen.current) {
            setBgGold("green");
          } else if (gold.rate < previousGoldOpen.current) {
            setBgGold("red");
          } else {
            setBgGold("#9c7726");
          }
        }

        if (silver && previousSilverOpen.current !== null) {
          if (silver.rate > previousSilverOpen.current) {
            setBgSilver("green");
          } else if (silver.rate < previousSilverOpen.current) {
            setBgSilver("red");
          } else {
            setBgSilver("#c0c0c0");
          }
        }

        // Update previous values
        if (gold) previousGoldOpen.current = gold.rate;
        if (silver) previousSilverOpen.current = silver.rate;

        setLiveRate(data);

        // Reset color after 1 second
        setTimeout(() => {
          setBgGold("");
          setBgSilver("");
        }, 1000);
      }),
    );
  };
  const normalizeName = (name) =>
    name?.toLowerCase().replace(/\s+/g, " ").trim();

  const getCommodity = (name) =>
    liveRate?.find(
      (item) => normalizeName(item?.commodity) === normalizeName(name),
    );

  const goldEntry = getCommodity("gold 24k");
  const silverEntry = getCommodity("silver");

  // const cartItems = useSelector((state) => state.cart);
  const cartItems = useSelector((state) => state?.popupTrigger?.cartItemCount);

  return (
    <>
      {/* {!hasSubscription && <Timer hasSubscription={hasSubscription} />} */}
      {/* {!isLoading && !hasSubscription && (
        <Timer hasSubscription={hasSubscription} />
      )} */}
      <header className="mainContainer-navbar">
        <div className="upperDiv">
          <p>Welcome to ZABALI</p>
        </div>
        <div className="lowerDiv">
          <div className="lower1">
            <div className="left-logo-side">
              <div className="hamburger" onClick={toggleMenu}>
                {/* <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
            <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
            <div className={`bar ${isMenuOpen ? "open" : ""}`}></div> */}
                {isMenuOpen ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    class="icon icon-close"
                    fill="none"
                    viewBox="0 0 18 17"
                  >
                    <path
                      d="M.865 15.978a.5.5 0 00.707.707l7.433-7.431 7.579 7.282a.501.501 0 00.846-.37.5.5 0 00-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 10-.707-.708L8.991 7.853 1.413.573a.5.5 0 10-.693.72l7.563 7.268-7.418 7.417z"
                      fill="currentColor"
                    ></path>
                  </svg>
                ) : (
                  <>
                    <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
                    <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
                    <div className={`bar ${isMenuOpen ? "open" : ""}`}></div>
                  </>
                )}
              </div>
              <div className="logo" onClick={handleLogoClick}>
                {/* <p className="zabali-text">ZABALI</p> */}
                <img
                  className="img-header-logoo"
                  src={Icons.zabali_header_logo_icon}
                  alt=""
                />
              </div>
            </div>
          </div>

          <nav className="lower2">
            <div className="lower2-upper">
              <div className="searchBar">
                <input
                  ref={searchInputRef}
                  className="search-input"
                  type="text"
                  placeholder='Search "jhumki"'
                  onChange={handleSearchChange}
                  value={searchTerm}
                />
                <img
                  className="search-icon-image"
                  src={Icons.searchIcon}
                  alt=""
                />

                {showDropdown && (
                  <div ref={dropdownRef} className="search-dropdown">
                    {searchResults
                      ?.filter(
                        (result) =>
                          Array.isArray(result.data) && result.data.length > 0,
                      )
                      .map((result, index) => (
                        <div key={index} className="category-section">
                          <div className="category-title">
                            {result.category}
                          </div>
                          <div className="product-list">
                            {result?.data?.length > 0 ? (
                              result?.data?.map((item, itemIndex) => {
                                return (
                                  <div
                                    key={itemIndex}
                                    className="search-dropdown-item"
                                    onClick={() => {
                                      setShowDropdown(false);
                                      handleClickOfTheProduct(item, result);
                                    }}
                                    style={{
                                      borderBottom: "1px solid #ccc", // Add bottom separator
                                      paddingBottom: "6px", // Add spacing below content
                                      marginBottom: "8px", // Space between items
                                    }}
                                  >
                                    <div>
                                      <div className="product-name">
                                        {item.product_name}
                                      </div>     
                                      {/* <div className="product-net-weight">
                                        {item.product_net_weight}{" "}
                                        {result?.category == "product_category"
                                          ? ""
                                          : "gm"}
                                      </div> */}
                                      {
                                        <div className="product-net-weight">
                                          {" "}
                                          {item?.product_code}
                                        </div>
                                      }
                                    </div>

                                    {/* {item?.product_images && ( */}
                                    <>
                                      <CustomImageComponent
                                        src={
                                          item?.product_images
                                            ?.product_image_url
                                        }
                                        height={56}
                                        width={56}
                                      />

                                      {/* <img
                                      src={
                                        item?.product_images?.[0]
                                          ?.product_image_url
                                          ? item?.product_images?.[0]
                                              ?.product_image_url
                                          : Icons.default_image
                                      }
                                      alt=""
                                      height={56}
                                      width={56}
                                    /> */}
                                    </>
                                    {/* )} */}
                                  </div>
                                );
                              })
                            ) : (
                              <div className="no-data-found">No data found</div>
                            )}
                          </div>
                        </div>
                      ))}
                  </div>
                )}

                {/* </div> */}
                <div className="language">
                  <div className="language-name">
                    <p>{selectedLanguage}</p>
                  </div>
                  <div className="image-icon" style={{ cursor: "pointer" }}>
                    <img
                      style={{ height: "16px", width: "24px" }}
                      className="icon india-icon"
                      src={Icons.indiaIcon}
                      alt="India"
                    />
                    <img
                      style={{ height: "7px", width: "14px" }}
                      className="icon down-carrot"
                      src={
                        isLanguageDropdownOpen
                          ? Icons.vectorUpIcon
                          : Icons.vectorDownIcon
                      } // Show up or down vector based on the state
                      alt="Dropdown"
                      onClick={handleOpenLanguagedropdown} // Handle click to open dropdown
                    />
                  </div>
                </div>

                {isLanguageDropdownOpen && (
                  <div className="language-dropdown">
                    <ul>
                      <li>
                        <input
                          type="radio"
                          id="en"
                          name="language"
                          value="EN"
                          checked={selectedLanguage === "EN"}
                          onChange={handleLanguageChange}
                        />
                        <label htmlFor="en">English</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          id="hi"
                          name="language"
                          value="HI"
                          checked={selectedLanguage === "HI"}
                          onChange={handleLanguageChange}
                        />
                        <label htmlFor="hi">Hindi</label>
                      </li>
                      <li>
                        <input
                          type="radio"
                          id="gj"
                          name="language"
                          value="GJ"
                          checked={selectedLanguage === "GJ"}
                          onChange={handleLanguageChange}
                        />
                        <label htmlFor="gj">Gujarati</label>
                      </li>
                      {/* Add more languages as needed */}
                    </ul>
                  </div>
                )}
              </div>
            </div>
            {/* <div className="lower2-lower">
              {menuData?.map((e) => {
                return (
                  <>
                    <ul className="menus" >
                      <li
                        className="list"
                        onClick={() => handleNavigate(e?.menu_slug)}
                        // onMouseEnter={() => {
                        //   if (e.menu_slug === "categories" && categoriesLoaded) {
                        //     setIsDropdownOpen(true);
                        //     // setHovering(true);
                        //   }
                        // }}
                        // onMouseLeave={() => setHovering(false)}

                        onMouseEnter={() => handleMouseEnter(e)}
                        onMouseLeave={handleMouseLeave}
                        // onMouseLeave={()=>{
                        //   setIsDropdownOpen(false)
                        // }}
                        // onMouseLeave={() => {
                        //   if (e?.menu_slug === "categories") {
                        //     setIsDropdownOpen(false); // Close dropdown when mouse leaves
                        //   }
                        // }}
                      >
                        {e?.menu_title}
                      </li>
                    </ul>
                  </>
                );
              })}
              <div className="dropdownn-menus">
                {isDropdownOpen && (
                  <SubcategoriesByCategory
                    setHovering={setHovering}
                    hovering={hovering}
                    setCategoriesLoaded={setCategoriesLoaded}
                    productCategory={productCategory}
                    ref={dropdownRef}
                  />
                )}
              </div>
            </div> */}
            <div className="lower2-lower">
              <ul className="menus">
                {menuData?.map((e) => (
                  <li
                    key={e.menu_slug}
                    className="list"
                    onClick={() => handleNavigate(e?.menu_slug)}
                    onMouseEnter={() => handleMouseEnter(e)}
                    onMouseLeave={handleMouseLeave}
                    style={{ position: "relative" }} // Required for dropdown positioning
                  >
                    {e?.menu_title}

                    {isDropdownOpen && e.menu_slug === "categories" && (
                      <div className="dropdownn-menus">
                        <SubcategoriesByCategory
                          setHovering={setHovering}
                          hovering={hovering}
                          setCategoriesLoaded={setCategoriesLoaded}
                          productCategory={productCategory}
                          ref={dropdownRef}
                        />
                      </div>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </nav>

          <div className="lower3">
            <div className="icons">
              <div
                className="icon-item cart-ico"
                style={{ cursor: "pointer", position: "relative" }}
                onClick={handleCartClick}
              >
                <img
                  style={{ height: "20px", width: "20px" }}
                  className="icon cart-icon"
                  src={Icons.cartIcon}
                  alt="Cart"
                />
                {cartItems > 0 && <span className="indicator-in-header"></span>}
                <p>Cart</p>
              </div>
              <div
                className="icon-item wishlist-ico"
                style={{ cursor: "pointer", position: "relative" }}
                onClick={handleWishlistClick}
              >
                <img
                  style={{ height: "20px", width: "20px" }}
                  className="icon wishlist-icon"
                  src={Icons.wishlistIcon}
                  alt="Wishlist"
                />
                {/* {1 > 0 && <span className="indicator-in-header"></span>} */}
                <p>Wishlist</p>
              </div>
              <div
                className="icon-item account-ico"
                style={{ cursor: "pointer" }}
                onClick={handleAccountClick}
              >
                <img
                  style={{ height: "20px", width: "20px" }}
                  className="icon account-icon"
                  src={Icons.accountIcon}
                  alt="Account"
                />
                <p>Account</p>
              </div>
            </div>
          </div>
        </div>
      </header>
      {/* {isAccountSideBarOpen && (
        <>
          <div className="overlay-account">
            <MyAccountSidebar
              isAccountSideBarOpen={isAccountSideBarOpen}
              toggleSidebar={() => setIsAccountSideBarOpen(false)}
            />
          </div>
        </>
      )} */}
      {isAccountSideBarOpen && (
        <div className="account-sidebar-wrapper">
          {/* Overlay click closes sidebar */}
          <div
            className="overlay-account"
            onClick={() => setIsAccountSideBarOpen(false)}
          />

          <MyAccountSidebar
            isAccountSideBarOpen={isAccountSideBarOpen}
            toggleSidebar={() => setIsAccountSideBarOpen(false)}
          />
        </div>
      )}
      <div className="live-rate-container">
        <div className="live-rate-text">
          {/* <p className="live-rate-label">Live rate :</p> */}
        </div>
        <div
          className="live-rate-btn-div gold-rate"
          style={{ backgroundColor: bgGold || "#9c7726" }}
        >
          <span>₹ Gold: {goldEntry?.rate}</span>
        </div>
        <div
          className="live-rate-btn-div silver-rate"
          style={{ backgroundColor: bgSilver || "#c0c0c0" }}
        >
          <span style={{ color: "#111111" }}>
            ₹ Silver: {silverEntry?.rate}
          </span>
        </div>
      </div>

      {isMenuOpen && (
        <nav className={`mobile-menu ${isMenuOpen ? "open" : ""}`}>
          <ul className="menu-list">
            {menuData?.map((e) => (
              <li
                className="list"
                key={e?.menu_slug} // Ensure a unique key is provided
                onClick={() => handleNavigate(e?.menu_slug)}
                onMouseEnter={() => {
                  if (e?.menu_slug === "categories") {
                    // handleNavigate(e?.menu_slug);
                    navigate("/shop-by-category", {
                      state: { fromShopByCategory: true },
                    });
                  } else {
                    setIsDropdownOpen(false);
                  }
                }}
                onBlur={() => {
                  setIsDropdownOpen(false);
                }}
              >
                {e?.menu_title}
              </li>
            ))}
          </ul>
          {/* <div className="mobile-account-section">
                <div
                  className="icon-item account-ico"
                  onClick={handleAccountClick}
                >
                  <img
                    style={{ height: "20px", width: "20px" }}
                    className="icon account-icon"
                    src={Icons.accountIcon}
                    alt="Account"
                  />
                  <p>Account</p>
                </div>
              </div> */}
        </nav>
      )}
    </>
  );
};
// Menu Item Component
// const MenuItem = ({ icon: Icon, label, className }) => (
//   <li
//     className={`flex items-center space-x-3 cursor-pointer p-2 hover:bg-gray-100 rounded-md ${className}`}
//   >
//     <Icon className="w-5 h-5 text-gray-600" />
//     <span>{label}</span>
//   </li>
// );
export default Header;
